import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { useBusiness } from "@/core/business";
import { PAYROLL_SETTINGS_ACCESS_PATH } from "@/payroll/settings/routes";

export const WorkbookAccessLink = ({
  children,
  userId,
}: {
  children: ReactNode;
  userId?: string;
}) => {
  const { businessId } = useBusiness();
  const params = new URLSearchParams();
  if (businessId) params.set("business", businessId);
  if (userId) params.set("person", userId);
  return (
    <Button
      variant="outline"
      nativeButton={false}
      render={<Link to={`${PAYROLL_SETTINGS_ACCESS_PATH}?${params}`} />}
    >
      {children}
    </Button>
  );
};
